//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import portalCommFileUpload from "@/pcpage/hr/recruitment/portal/component/portalCommFileUpload";
import * as axios from "@/store/http";
import * as auth from "@/utils/auth";
export default {
  extends: portalCommFileUpload,
  name: "portalFileUplaod",
  props: {
    // 弹窗按钮名称
    btnName: {
      type: String,
      default: "Upload Attachment *",
    },
    uploadTitle: {
      type: String,
      default: "",
    },
    fileForm: {
      type: Object,
      default: () => ({}),
    },
    keyval: {
      type: String,
      default: "",
    },
    accountid: {
      //账号ID
      type: String,
      default: "",
    },
    // 回调函数
    callbackFun: {
      type: Function,
      default: null,
    },
    checkUploadkFun: {
      type: Function,
      default: null,
    },
    matchItem: {
      type: String,
      default: "",
    },
    editItem: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      titleName: this.$t("contract.btnUploadFile"),
    };
  },
  methods: {
    initFileConfig() {
      //初始化文件配置
      let params = {
        record: {
          btype: this.fileForm.btype,
          docutypeid: this.fileForm.docutypeid,
        },
      };
      axios.post(this.getdoctype, params).then((res) => {
        if (res.data.code == "1") {
          let docuinfo = res.data.data.record.docuinfo;
          if (docuinfo != undefined) {
            this.tagName = docuinfo.tagname;
            this.tabName = docuinfo.tabname;
            this.limitNum = docuinfo.limitnum;
            this.acceptType = docuinfo.filetype;
            this.docuTypeId = docuinfo.docutypeid;
            this.maxSize = docuinfo.maxsize;
            this.btype = docuinfo.btype;
            this.chunkSize = docuinfo.chunksize;
            this.ifChunkSize = docuinfo.ifchunksize;
            if (
              this.limitNum > 1 ||
              this.limitNum == undefined ||
              this.limitNum == ""
            ) {
              this.showmultiple = true;
            }
          }
        }
      });
    },
    handleDialogClose() {
      //点击X时关闭事件
      if (this.showFileList.length == 0) {
        this.dialogVisible = false;
      }
    },
    submitUpdateData() {
      if (this.showFileList.length == 0) {
        this.dialogVisible = false;
        return;
      }
      if (!this.checkFileUploadSuccess()) {
        this.$message.warning(this.$t("contractcheck.checkUploadSuccess"));
        return;
      }
      this.showFileList = [];
      if (this.callbackFun) {
        this.dialogVisible = false;
        //通过回调函数，回传附件ID
        this.callbackFun();
      }
    },
    checkFileUploadSuccess() {
      //验证附件是否上传成功
      let flag = true;
      for (let i = 0; i < this.showFileList.length; i++) {
        let status = this.showFileList[i].status;
        if (status != "success") {
          flag = false;
          break;
        }
      }
      return flag;
    },
    openModel() {
      this.setDialogPos();
    },
  },
  watch: {
    keyval: {
      immediate: true, // 这句重要
      handler(val) {
        this.keyval = val;
      },
    },
  },
  computed: {
    readonly: function () {
      if (this.editItem.indexOf(";" + this.matchItem + ";") === -1) {
        //返回true,设为只读
        return true;
      } else {
        return false;
      }
    },
  },
  created() {
    this.initFileConfig();
  },
};



// WEBPACK FOOTER //
// ./src/pcpage/hr/recruitment/portal/component/PortalFileUpload.vue